import api from './api';

export const getChannelPlansBySlug = (slug) => {
  return api.get(`plan/${slug}`);
}

export const addRewardToPlan = (channelUid, planUid, rewardName) => {
  return api.post('admin/plan/add-reward', { channelUid, planUid, rewardName });
};

export const removePlanReward = (planUid, rewardId) => {
  return api.put('admin/plan/remove-reward', { planUid, rewardId });
};

export const getChannelSubscriptionPlans = (page, params) => {
  return api.get('admin/Plans', { params: { page: page, limit: 5, ...params } });
};

export const getChannelRewards = (page, params) => {
  return api.get('admin/Reward', { params: { page: page, limit: 5, ...params } });
};